const LANGUAGE_MAPPING = {
  add: 'Add',
  addressParts: {
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
  },
  accountDialog: {
    changeEmail: 'Change Email',
    changePassword: 'Change Password',
    confirmNewEmail: 'Confirm New Email',
    confirmNewPassword: 'Confirm New Password',
    currentPassword: 'Current Password',
    emailsMustMatch: 'Emails must match',
    mustProvidePassword:
      'You must provide your current password to update your account details.',
    newEmail: 'New Email',
    passwordsMustMatch: 'Passwords must match',
  },
  alreadyHaveAccountMessage: 'Already have an account?',
  alreadyHaveAccountLink:
    'Already have an account? <a href="/sign_in">Sign In</a>',
  annotationPanel: {
    changesSaved: 'Annotation changes saved.',
    requestUnderwayMessage: 'Your request is being processed',
    saveError: 'Error saving Annotation changes. Please try again later.',
  },
  assessments: {
    loading: 'Loading assessment...',
    pharmacySelect: {
      addPharmacy: 'Add Pharmacy',
      nearAddress: 'Near Address',
      noSearchResults:
        'No results found. Click the "Back" button to refine your search.',
      pharmacyInfo: 'Pharmacy Info',
      pharmacySearch: 'Pharmacy Search',
      pharmacySearchHelpText:
        'Please provide a Zip code or City and State to perform a search. You can also provide a name to help narrow the results.',
      searchResults: 'Pharmacy Search Results',
      specialtyLabels: {
        all: 'All',
        mailOrder: 'Mail Order',
        twentyFourHour: '24-Hour',
      },
    },
  },
  cancel: 'Cancel',
  changeMyPassword: 'Change My Password',
  changeYourPassword: 'Change Your Password',
  channelsOfCare: {
    chatNow: 'Chat Now',
    contactSupport: 'Contact Support',
    emergencyMessage:
      'If you think you or a family member is having a medical or psychiatric emergency, call 911. Do not attempt to access emergency care through this app.',
    header: 'Who would you like to chat with?',
    joinQueue: 'Join Queue',
    logOut: 'Log Out',
    noChatsBody:
      "We couldn't find any plans of the specified type associated with your account. Choose an option below to continue:",
    noChatsFound: 'No Chats Found',
    serviceClosed: 'Service Closed',
    viewAllPlans: 'View All Plans',
  },
  closeMenu: 'Close Menu',
  closeModal: 'Close modal',
  confirmLeaveApp:
    'You are about to leave the app to use our Find Local Care feature.',
  continue: 'Continue',
  contrasts: {
    decrease: 'Decrease contrast',
    increase: 'Increase contrast',
  },
  copy: 'Copy',
  createDependentDialog: {
    addDependent: 'Add a minor dependent',
    checkboxCopy:
      'By checking this box and proceeding, I confirm that I am the parent or legal guardian of %{firstName} %{lastName} born %{dob} and I am authorized to receive their health information.',
    dependentHeader: "Minor dependent's Information:",
    fillInfo:
      'Fill in the information below so that you can get care for your minor dependent. Only children under %{age} can be added.',
    firstName: 'First Name',
    lastName: 'Last Name',
    letsAddDependent: "Let's add a minor dependent!",
  },
  createPassword: 'Create Password',
  dateOfBirth: 'Date of Birth',
  dateParts: {
    day: 'Day',
    month: 'Month',
    year: 'Year',
  },
  dependent: 'dependent',
  dependentCard: {
    display: '%{gender} | Age %{age}',
  },
  edit: 'Edit',
  edited: ' Edited',
  email: 'Email',
  encountersPage: {
    enterName: "Enter a patient's last name to search.",
    noEncountersFound: 'There were no encounters found',
    noPatientsFound: 'There were no patients found',
  },
  enterChat: 'Enter Chat',
  exitQueue: 'Exit Queue',
  exitQueueDialog: {
    confirmation: 'Are you sure?',
    endSession: 'End Session',
    exitDisclaimer:
      'By exiting the queue you will lose your place in line and end your session.',
    stayInQueue: 'Stay In Queue',
  },
  familySettings: 'Family Settings',
  faq: 'Click Here to View FAQ',
  fileBrowser: {
    unsupportedFormat:
      'Unsupported image format. We accept the following formats: JPG, PNG, GIF, Bitmap. We ask that you use your best judgment when uploading digital images.If you are under 18, consult a parent or guardian before uploading any photos that may be questionable.',
    uploadImage: 'Upload image',
  },
  fontSizes: {
    bigger: 'Bigger',
    biggest: 'Biggest',
    default: 'Default',
    increaseFontSize: 'Increase font size',
  },
  forgotPasswordPage: {
    emailInstructions:
      'Please check your email and follow instructions to reset your password.',
    emailSentNotice: 'We sent you an email!',
    formDescription:
      "Please enter the email address associated with your account, and we'll send you an email with a link to reset your password.",
    header: 'Forgot Password?',
    nowWhat: 'Now what?',
    pageTitle: 'Forgot Password',
    spamLinkText: 'try a different email.',
    spamNotice: "Don't see an email? Check your junk and spam folders or",
  },
  formElementHelpers: {
    charsRemaining: '%{num} characters remaining',
  },
  formPlaceholders: {
    email: 'name@example.com',
  },
  fullScreenControls: {
    enterFullscreen: 'Enter Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
  },
  gender: 'Gender',
  genderIdentity: 'Gender Identity',
  genderIdentities: {
    female: 'Female',
    genderFluid: 'Gender fluid',
    genderNonConforming: 'Gender Non-conforming',
    intersex: 'Intersex',
    male: 'Male',
    nonBinary: 'Non-binary',
    other: 'Other',
    transgender: 'Transgender',
    twoSpirit: 'Two Spirit',
    somethingElse: 'Something Else',
    noDisclose: 'Do not wish to disclose',
    unknown: 'Unknown',
  },
  getStarted: 'Get Started',
  healthInsuranceProvider: 'Health Insurance Provider',
  heightOption: '%{totalInches} inches (%{feet}\' %{inches}")',
  helloWorld: 'Hello World',
  hi: 'Hi',
  hidePassword: 'Hide Password',
  isTyping: 'is typing...',
  locationInquiry: 'Which state are you currently in?',
  medicalInfoCard: {
    allergiesLabel: 'Allergies / Drug Sensitivities',
    clickToEdit: 'Click text to edit',
    historyLabel: 'Medical Conditions / History',
    pleaseReview: 'Please review and confirm your health information.',
    prescriptionLabel: 'Prescriptions & Medications',
  },
  messageFailedToSend: 'Message Failed to Send',
  messageInput: {
    channelDeactivated: 'This Channel has been deactivated for this patient',
    sendMessage: 'Send Message',
    typeMessage: 'Type Message',
    typeMessageFor: 'Type Message for %{name}',
  },
  minorDependent: 'Minor dependent',
  my: 'My',
  name: 'Name',
  needInvitation: 'Need an invitation?',
  needInvitationLink:
    'Need an invitation? <a href="/invitation/resend">Send a request.</a>',
  newPassword: 'New Password',
  newPasswordConfirmation: 'New Password Confirmation',
  notificationLinkMessages: {
    abandonGoal: {
      success: 'Goal abandoned',
    },
    genericError:
      'An error occurred and changes could not be saved. Please try again.',
    somethingWentWrong: 'Something went wrong',
    success: 'Success!',
    patientStream: {
      networkError:
        'Unable to find message streams - please refresh the page or contact support',
    },
    updateDependentProfile: {
      success: 'Family Member Saved',
    },
    updatePatientProfile: {
      error: 'Profile failed to update',
      success: 'Profile was updated',
    },
    updateAccount: {
      success: {
        email: 'Email Saved',
        password: 'Password Saved',
      },
    },
    completeEncounter: {
      success: 'Progress Note Created',
    },
    completeGoal: {
      success: 'Goal Completed',
    },
    createDependent: {
      success: 'Your minor dependent was added to your account!',
    },
    createGoal: {
      success: 'Goal was created',
    },
    createGoalNote: {
      success: 'Goal note was created',
    },
    createReminder: {
      success: 'Reminder Created',
    },
    deleteMessage: {
      networkError: 'Unable to delete message - please contact support',
    },
    deleteReminder: {
      networkError: 'Unable to delete reminder - please contact support',
      success: 'Reminder Deleted',
    },
    deleteStandardPhrase: {
      networkError: 'Unable to delete phrase - please contact support',
      success: 'Phrase Deleted',
    },
    dismissEncounter: {
      networkError: 'Unable to dismiss encounter - please contact support',
    },
    publishPatientNote: {
      error: 'Error publishing note',
      success: 'Sent to CPRS',
    },
    recordPatientMeasurement: {
      error: 'Unable to record measurement - please contact support',
    },
    shareLabOrderToStream: {
      error:
        'Unable to share Lab Results Images with Patient - please contact support',
      success: 'Lab Results Images Shared with Patient',
    },
    transferEncounter: {
      success: 'Transfer Successful',
    },
    updateGoal: {
      success: 'Goal Updated',
    },
    updatePatient: {
      error: 'Unable to Update Patient',
      success: 'Patient Updated',
    },
    updateProgressNote: {
      success: 'Progress Note Updated',
    },
    updateProviderProfile: {
      error: 'Profile failed to update',
      success: 'Profile was updated',
    },
    updateReminder: {
      success: 'Reminder Updated',
    },
  },
  notVerified: 'Not verified',
  pagination: {
    back: 'Back',
    next: 'Next',
  },
  password: 'Password',
  passwordConfirmation: 'Password Confirmation',
  passwordRules:
    '<div style="text-align:left;width:100%"><b>Password rules:</b></div><ul style="text-align:left;margin-block-end:0;margin-block-start:8px"><li>At least 8 characters.</li><li>At least 1 number.</li><li>Both uppercase and lowercase letters.</li><li>At least 1 special character (i.e. ! # ?)</li></ul>',
  patient: 'Patient',
  patientLocation: {
    accountSettings: 'Account Settings.',
    description:
      'Your current location helps us connect you to the right providers and resources.',
    dependentDescription:
      'You and your minor dependent must be in the same location.',
    displayNameDescription:
      'We default to your legal name, but you can change your preferred name in your ',
    readyForVisit: 'Ready for a visit?',
    readyForVisitConfirm: 'Ready for a visit? Please confirm your location.',
  },
  patientCostAndQualityPage: {
    pageTitle: 'Find Local Care',
    startChat: {
      cta: 'Start Chat',
      text: 'Connect with a board certified physician in 60 seconds or less.',
    },
  },
  patientGoalsPage: {
    pageTitle: 'Goals',
    status: {
      completed: 'Completed',
      in_progress: 'Active',
      initiated: 'Upcoming',
    },
    zeroState: 'You do not currently have any %{status} goals.',
    zeroStateDependent: '%{name} does not currently have any %{status} goals.',
  },
  patientLabOrdersPage: {
    ordered: 'Ordered %{date}',
    orderedBy: 'Ordered by %{name}',
    orders: 'Orders',
    pageTitle: 'Lab Orders',
    received: 'Received %{date}',
    results: 'Results',
    status: {
      lab_orders: 'Labs Ordered',
      lab_results: 'Lab Results',
    },
    viewOrders: 'View Order',
    viewResults: 'View Results',
    zeroState: {
      lab_orders: 'No lab orders found',
      lab_results: 'No lab results found',
    },
  },
  patientSettingsPage: {
    accessibilityHeader: 'Accessibility Support',
    audioNotificationHeader: 'Audio Notifications',
    insurance: 'Insurance',
    leadInHeader:
      "You're the boss of your account, personalize your experience here.",
    medical: 'Medical',
    myAccount: 'My Account',
    myFamily: 'My Family',
    playSound: 'Play an audible sound when a new message arrives',
    preferences: 'Preferences',
    preferredLanguageHeader: 'Preferred Language',
    revokeConsentDescription:
      'Update your SSO consent by adjusting the toggle to instantly update your preferences. If you haven\'t clicked the SSO button associated with the toggle yet, the switch will be disabled. Once you\'ve clicked the SSO button and clicked "yes" to consent, the toggle will be enabled. If you change your mind, simply slide the toggle "off." You can easily reinstate your consent at any time by sliding the toggle "on."',
    revokeConsentHeader: 'Quickly manage how you access services with SSO',
    revokeCostAndQualitySsoConsentLabel: 'Find Local Care',
  },
  pcp: 'Primary Care Physician (PCP)',
  pending: 'Pending ...',
  pleaseSelectOption: 'Please select an option',
  phone: 'Phone',
  preChatPage: {
    body: 'Please select the chat that best meets your needs.',
    createAccountDisclaimer: 'Adults need to create their own account.',
    selectChat: 'Select a chat.',
    selectProfile: 'Select a profile.',
    welcome: 'Welcome',
  },
  preferredLanguage: 'Preferred language',
  preferredLanguageDialog: {
    autoTranslateDisclaimer:
      'You are about to enable automatic translation to translate between Spanish and English.',
    disableDisclaimer:
      'You can turn off automatic translation at any time in the settings tab or navbar.',
    header: 'Do you want to change languages?',
    reloadDisclaimer: 'Upon confirming your page will reload.',
    rttDisclaimer:
      'You will be able to use real-time translations for chat messages and progress notes in your preferred language.',
    staticTextDisclaimer:
      'All static content will translate to the selected language.',
    thirdPartyDisclaimer:
      'Due to 3rd party technology limitations, translation errors may occur. You can turn off automatic translations at any time in settings.',
  },
  preScreen: {
    hello: 'Hello!',
    providerHelp: 'Let our providers know how they may help.',
    startChat:
      'Simply start your chat with a hello, and if you wish, include a reason for chatting today.',
  },
  primary: 'Primary',
  printForPcp: 'Print for PCP',
  privacyLink:
    '<a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Privacy Policy</a>',
  privacyPolicy: 'Privacy Policy',
  profileMenu: 'Profile menu',
  pronouns: 'Pronouns',
  provider: 'Provider',
  providerInfoPanel: {
    about: 'About Your Provider',
    meet: 'Meet',
  },
  providerVerifyPhone: {
    buttonText: 'Verify My Phone Number',
    header: 'Phone Number Verification Required',
    helperText:
      'As a part of our continued commitment to information security, we have upgraded our SMS notification system. The upgrade will require you to provide and verify your phone number to continue to receive SMS notifications.',
  },
  registrationPage: {
    dobInvalid: 'Date of birth is invalid',
    invalidFormInfo:
      'The form contains invalid information. Please address the issues and try again.',
    pageTitle: 'Registration',
    welcome:
      'Welcome! We are happy to have you here. Please fill in the form below to start the registration process.',
  },
  raceEthnicities: {
    americanIndian: 'American Indian or Alaska Native',
    asian: 'Asian',
    africanAmerican: 'Black or African American',
    hispanic: 'Hispanic, Latino, or Spanish Origin',
    middleEastern: 'Middle Eastern or North African',
    hawaiian: 'Native Hawaiian or Other Pacific Island',
    white: 'White',
    multiEthnic: 'Multiethnic',
    noAnswer: 'Prefer not to answer',
    somethingElse: 'Something Else',
  },
  registerInvitationPage: {
    agree: {
      toFinancialResponsibility:
        'I agree to the <a href="%{href}" rel="noreferrer nofollow noopener "target="_blank">Patient Financial Responsibility Agreement</a>',
      toInformedConsent:
        'I agree to the <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Patient Informed Consent</a>',
      toInformedConsentAndPrivacyPractices:
        'I agree to the <a href="%{consentHref}" rel="noreferrer nofollow noopener" target="_blank">Patient Informed Consent</a> and <a href="%{noticeHref}" rel="noreferrer nofollow noopener" target="_blank">Notice of Privacy Practices</a>',
      toPrivacyPolicy:
        'I agree to the <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Privacy Policy</a>',
      toPrivacyPractices:
        'I agree to the <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Notice of Privacy Practices</a>',
      toSmsMarketing:
        '<b>Optional:</b> By checking this box, I agree to CirrusMD SMS Marketing <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Terms and Conditions</a> and authorize CirrusMD to contact me at the phone number provided through my membership or profile via SMS text message using automated dialing technology for marketing and/or advertising purposes. I understand that I do not have to grant consent to CirrusMD and that message and data rates may apply. Message frequency varies. Text HELP for help. To opt-out or revoke consent, reply STOP to any SMS text message.',
      toTermsLabel: 'I have read and agree to the terms and conditions',
      toTermsOfUse:
        'I agree to the <a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Terms of Use</a>',
      toTermsOfUseAndPrivacyPolicy:
        'I agree to the <a href="%{termsHref}" rel="noreferrer nofollow noopener" target="_blank">Terms of Use</a> and <a href="%{privacyHref}" rel="noreferrer nofollow noopener" target="_blank">Privacy Policy</a>',
      youAgreePrefix: 'By registering, you agree to our',
    },
    pageDescription:
      'Your privacy and consent are important to us. Please select each box to indicate you agree.',
    pageHeader: 'Terms and Agreements',
    pageTitle: 'Complete Your Registration',
    submitLabel: 'Register',
  },
  requiredFieldsExplanation: 'Fields marked with an asterisk (*) are required',
  resend: 'Resend',
  resendInvitationPage: {
    formDescription:
      "Please enter the email address associated with your account, and we'll send you an email with instructions on how to register your account.",
    pageTitle: 'Resend Your Invitation',
  },
  revealPassword: 'Reveal Password',
  save: 'Save',
  saved: 'Saved',
  search: 'Search',
  select: 'Select',
  selectState: 'Select State',
  send: 'Send',
  sendInstructions: 'Send Instructions',
  sendRequest: 'Send a request.',
  settings: 'Settings',
  settingsDependent: {
    description:
      'Your minor dependents are a part of your account; chatting on behalf of them requires no extra logins or complicated steps. Simply switch between profiles and start chatting with a provider.',
    title: "Managing your family's health has never been this easy",
  },
  settingsMyAccount: {
    accountDetails: 'Account Details',
    demographicDescription:
      'Help us ensure our platform is providing equitable care. Your answers are optional and will not be shown to your provider.',
    keepProfileUpdated:
      'Keep your profile information up to date so we may provide you the best care.',
    legalFirstName: 'Legal First Name',
    legalLastName: 'Legal Last Name',
    moreInfo: 'More Information',
    preferredFirstName: 'Preferred First Name',
    profile: 'Profile',
    race: 'Race/Ethnicity',
    selectGenderIdentity: 'Select a gender identity...',
    selectRace: 'Select a race/ethnicity...',
    selectSex: 'Select a sex...',
    sexAssignedAtBirth: 'Sex Assigned at Birth',
  },
  shareFeedback: 'Share Feedback',
  sidebarHeader: '%{name} Healthcare Services',
  signIn: 'Sign In',
  signInPage: {
    agreeText: 'By signing in, you agree to our',
    forgotPasswordLink: '<a href="/password/new">Forgot your password?</a>',
    header: 'Sign In to Your Account',
    registerLink:
      'Don\'t Have an Account? <a href="%{registerHref}">Register Here</a>',
    welcomeBack:
      'Welcome back! Sign in with the information you entered during registration.',
  },
  signOut: 'Sign Out',
  skip: 'Skip',
  specialties: 'Specialties',
  status: 'Status',
  stickyFooter: {
    needSupport: 'Need Technical Support?',
    reportConcern: 'Report a Medical Care Concern?',
  },
  streamMessages: {
    exitAssessment:
      'Are you sure you want to exit this assessment? Your progress will be lost if you close this modal.',
    printDocNote: "Please check your email to print your doctor's note.",
    videoSessionExpired:
      'Video session is expired. The provider will need to initiate a new video session.',
  },
  streamMessageTitles: {
    closed: 'Closed',
    nonBillableNote: 'Clinical Documentation Note',
    patientEndedChat: 'Patient Ended Chat',
    progressNote: 'Progress Note',
    questionsSummary: '%{identifier} Questions Summary',
    transferred: 'Transferred',
  },
  submit: 'Submit',
  submitFeedback: 'Submit Feedback',
  surveys: {
    close: 'Close',
    excellent: 'Excellent',
    good: 'Good',
    modalCloseTitle: 'Close survey thank-you message',
    needsImprovement: 'Needs Improvement',
    negative: 'Negative experience',
    okay: 'Okay',
    poor: 'Poor',
    positive: 'Positive experience',
  },
  termsAndAgreements: {
    agreeToFinancialResponsibility:
      'I agree to the <a href="%{url}" rel="noreferrer nofollow noopener "target="_blank">Patient Financial Responsibility Agreement</a>',
    agreeToInformedConsent:
      'I agree to the <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Patient Informed Consent</a>',
    agreeToPrivacyPolicy:
      'I agree to the <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Privacy Policy</a>',
    agreeToPrivacyPractices:
      'I agree to the <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Notice of Privacy Practices</a>',
    agreeToTerms:
      'I agree to the <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Terms of Use</a>',
    agreeToTextMessageMarketingAgreement:
      '<b>Optional:</b> By checking this box, I agree to CirrusMD SMS Marketing <a href="%{url}" rel="noreferrer nofollow noopener" target="_blank">Terms and Conditions</a> and authorize CirrusMD to contact me at the phone number provided through my membership or profile via SMS text message using automated dialing technology for marketing and/or advertising purposes. I understand that I do not have to grant consent to CirrusMD and that message and data rates may apply. Message frequency varies. Text HELP for help. To opt-out or revoke consent, reply STOP to any SMS text message.',
    heading: 'Terms and Agreements',
  },
  termsAndPrivacyLink:
    '<a href="%{termsHref}" rel="noreferrer nofollow noopener" target="_blank">Terms of Use</a> and <a href="%{privacyHref}" rel="noreferrer nofollow noopener" target="_blank">Privacy Policy</a>',
  termsAndPrivacyPolicy: {
    informedConsent: 'Informed Consent',
    noticeOfPrivacy: 'Notice of Privacy Practices',
    patientFinancial: 'Patient Financial Responsibility Agreement',
  },
  termsLink:
    '<a href="%{href}" rel="noreferrer nofollow noopener" target="_blank">Terms of Use</a>',
  termsOfUse: 'Terms of Use',
  translatedByText: 'Provided via automatic translation',
  unsupportedBrowser:
    'You are using an unsupported browser, pleaswe use the latest desktop version of Chrome, Firefox or Edge.',
  updateDependentDialog: {
    addProfileImage: 'Add Profile Image',
    editFamilyMember: 'Edit Family Member',
  },
  uploads: {
    imageDescription: 'Image Description',
    imageFormatDisclaimer:
      'We accept the following formats: JPG, PNG, GIF, Bitmap. We ask that you use your best judgment when uploading digital images.',
    instructions: 'Upload instructions',
    upload: 'Upload',
    uploadPhoto: 'Upload Photo',
  },
  validations: {
    exactLength: 'Must be exactly %{numChars} characters.',
    minLength: 'Must be at least %{numChars} characters.',
    required: 'Field is required.',
  },
  verify: 'Verify',
  verifyHealthInsurance: 'Verify Health Insurance',
  verifyInsurance: 'Verify Insurance',
  verifySubscriberIdDialog: {
    bannerText: 'We are verifying your benefits, this can take up to a minute.',
    description:
      'Before starting a chat, you will need to confirm your account by entering your',
    errorText: 'Health insurance not verified',
    havingTrouble: 'Having Trouble? Contact support at',
    idCardSuffix: 'can be found on your health insurance card',
    verifyWarning:
      "Please don't close or refresh this modal while we verify your information.",
  },
  videoSession: {
    accessDenied:
      'Oops! Access to your camera and mic has been blocked. Please grant access in your browser settings.',
    connectingText: 'Connecting to a video session.',
    endTitle: 'End',
    leavePageConfirmation: 'Are you sure you want to leave this page?',
    patientVideoUnavailable: 'Video disabled.',
    providerVideoUnavailable: 'Provider video is unavailable.',
    sessionEnded: '%{actor} has ended the video session.',
    waitingToConnect: 'Waiting for %{actor} to connect.',
  },
  websocketBanner: {
    healthInsuranceVerified: 'Your health insurance has been verified!',
    newVersion: 'A new version of the page is available.',
    reloadPage: 'Reload Page',
    reconnectingIn: 'Reconnecting in %{seconds} seconds.',
    reconnectNow: 'Reconnect Now',
    reconnectingNow: 'Reconnecting now...',
  },
  welcomeMessage: {
    helperText: "We're glad you're here",
    subtitle:
      "You're ready to start a chat or explore! We'll confirm some details and help you get to the right place.",
  },
  your: 'Your',
  zipCode: 'Zip Code',
}

export default LANGUAGE_MAPPING
